// extracted by mini-css-extract-plugin
export var alignDiscLeft = "q_qt d_fl d_bC d_dr";
export var alignLeft = "q_p5 d_fl d_bC d_dr";
export var alignDiscCenter = "q_qv d_fm d_bz d_ds";
export var alignCenter = "q_bL d_fm d_bz d_ds";
export var alignDiscRight = "q_qw d_fn d_bD d_dt";
export var alignRight = "q_p6 d_fn d_bD d_dt";
export var footerContainer = "q_qx d_dS d_bS";
export var footerContainerFull = "q_qy d_dQ d_bS";
export var footerHeader = "q_kc d_kc";
export var footerTextWrapper = "q_qz d_s";
export var footerDisclaimerWrapper = "q_kk d_kk d_cg";
export var badgeWrapper = "q_qB d_s d_bw d_bL d_bB d_bF";
export var footerDisclaimerRight = "q_kl d_kl d_bw";
export var footerDisclaimerLeft = "q_km d_km d_bw";
export var verticalTop = "q_qC d_bw d_bF d_bK d_bH";
export var firstWide = "q_qD";
export var disclaimer = "q_qF";
export var socialDisclaimer = "q_qG";
export var left = "q_qH";
export var wide = "q_qJ d_cv";
export var right = "q_qK d_bG";
export var line = "q_fg d_fh d_cr";
export var badgeDisclaimer = "q_qL d_by d_bL d_bF";
export var badgeContainer = "q_qM d_bw d_bD d_bL";
export var badge = "q_qN";
export var padding = "q_qP d_c4";
export var end = "q_qQ d_bD";
export var linkWrapper = "q_qR d_dx";
export var link = "q_mF d_dx";
export var colWrapper = "q_qS d_ct";
export var media = "q_qT d_bt d_dv";
export var itemRight = "q_qV";
export var itemLeft = "q_qW";
export var itemCenter = "q_qX";
export var exceptionWeight = "q_qc x_sd";